var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"newcomer-campaign"},[_c('section',{staticClass:"campaign-content"},[_c('img',{staticClass:"campaign-hero",attrs:{"src":_vm.heroImage,"alt":"新人专享大礼包"}}),_c('img',{staticClass:"campaign-coupons",attrs:{"src":_vm.couponImage,"alt":"新人专享优惠券"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }